module.exports = __webpack_public_path__ + "static/media/background-4.cdd711e3.jpg";